<nz-layout>
  <nz-content>
    <ng-container>
      <app-reusable-table
        title="Dietary Habits"
        [columns]="['Dietary Habits', 'Unit Amount', 'Timing Unit']"
        [rowFields]="['dietTypeName', 'unitAmount', 'customTimingUnit']"
        [data]="dietaryHabits"
        [addComponent]="addComp"
        [deleteFun]="deleteFun"
        [isLoading]="isLoading"
        [openModalFun]="openModalFun"
        [isPreview]="false"
        [addPermissions]="['a-d-h']"
      />
    </ng-container>
  </nz-content>
</nz-layout>
